const URL = (process.env.NODE_ENV === 'production') ? 'https://xqckapi.ddtmx.com/' : 'http://localhost:21021/';
export default URL;